import { useState, useEffect } from "react";
import { getDocument } from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.min.mjs";
import { getInstructionsPdfBase64 } from "../pdfAssets";

export const usePdfInstructions = (formLanguage) => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const renderPdf = async () => {
      setPages([]);
      const base64 = getInstructionsPdfBase64(formLanguage);
      if (!base64) return;

      try {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

        const pdf = await getDocument({ data: bytes }).promise;
        const loaded = [];

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 2.0 });
          const canvas = document.createElement("canvas");
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          await page.render({ canvasContext: canvas.getContext("2d"), viewport, intent: "display" }).promise;
          loaded.push(canvas.toDataURL("image/png", 1.0));
        }

        setPages(loaded);
      } catch (err) {
        console.error("Error loading PDF:", err);
      }
    };

    renderPdf();
  }, [formLanguage]);

  const downloadPdf = () => {
    const base64 = getInstructionsPdfBase64(formLanguage);
    if (!base64) return;
    try {
      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `instructions-${formLanguage}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      // Silently fail — PDF asset may be unavailable
    }
  };

  return { pages, downloadPdf };
};
